var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"avue-contail blue-theme"},[_c('div',{staticClass:"avue-header"},[_c('top')],1),_c('div',{staticClass:"avue-main"},[_c('router-view')],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }